var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseNewForm',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v(" "+_vm._s(_vm.getTitle)+" ")]},proxy:true}])},[_c('div',{staticClass:"quote"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }